/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Offset_From_EndInputs */

const en_templates_offset_from_end = /** @type {(inputs: Templates_Offset_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(from end)`)
};

const he_templates_offset_from_end = /** @type {(inputs: Templates_Offset_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(מהסיום)`)
};

/**
* | output |
* | --- |
* | "(from end)" |
*
* @param {Templates_Offset_From_EndInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_offset_from_end = /** @type {((inputs?: Templates_Offset_From_EndInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Offset_From_EndInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_offset_from_end(inputs)
	return he_templates_offset_from_end(inputs)
});